module.exports = __webpack_public_path__ + "static/img/code3.fb4b3d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code3.jpg
// module id = iljD
// module chunks = 128